import { Controller } from "@hotwired/stimulus"

// Extra numbers and emails on a person (shared/_endpoint_fields): clones a
// template row with the next index, carrying the form= attribute when the
// fields belong to a carrier form (the client page pattern), and drops an
// unsaved row. Saved rows are removed through their Remove checkbox so the
// server sees _destroy.
export default class extends Controller {
  static targets = ["rows", "row", "phoneTemplate", "emailTemplate", "addressTemplate"]
  static values = { prefix: String, form: String }

  add(event) {
    const kind = event.currentTarget.dataset.kind
    const tpl = kind === "email" ? this.emailTemplateTarget : kind === "address" ? this.addressTemplateTarget : this.phoneTemplateTarget
    const i = Date.now()
    const html = tpl.innerHTML.replaceAll("__PREFIX__", this.prefixValue).replaceAll("__I__", String(i))
    const wrap = document.createElement("div")
    wrap.innerHTML = html.trim()
    const row = wrap.firstElementChild
    if (this.formValue) row.querySelectorAll("input, select").forEach((el) => el.setAttribute("form", this.formValue))
    this.rowsTargets.find((t) => t.dataset.kind === kind).appendChild(row)
    row.querySelector(".ep-value").focus()
  }

  drop(event) {
    event.currentTarget.closest("[data-endpoint-fields-target='row']").remove()
  }
}
